{
  "blocks": [
    {
      "id": "module-fertilization-culture",
      "kind": "module",
      "tags": ["both-partners", "treatment", "during-cycle"],
      "title": "Fertilization & Culture",
      "subtitle": "Fertilization, embryo development to blastocyst stage",
      "icon": "🧬",
      "body": {
        "duration": "5–7 days",
        "category": "treatment",
        "forWhom": "both",
        "includes": [
          "Sperm preparation and selection",
          "Conventional IVF or ICSI fertilization",
          "Day-1 fertilization report (how many fertilized)",
          "Day-3 development update (cell count, grade)",
          "Day-5/6 blastocyst report (how many reached blastocyst, grades)",
          "Cryopreservation of viable blastocysts"
        ],
        "priceRange": {
          "low": 2000,
          "high": 4000
        },
        "currency": "USD",
        "status": "coming-soon",
        "steps": [
          {
            "title": "Fertilization (Day 0)",
            "description": "Eggs and sperm are combined via conventional IVF or ICSI. Results reported next morning."
          },
          {
            "title": "Early development (Day 1–3)",
            "description": "Fertilized eggs (zygotes) begin dividing. Day-3 update on cell count and quality."
          },
          {
            "title": "Blastocyst stage (Day 5–6)",
            "description": "Embryos that reach blastocyst are graded and either frozen or prepared for transfer."
          }
        ]
      },
      "sources": [
        {
          "title": "Blastocyst culture and transfer in clinical-assisted reproduction",
          "journal": "Human Reproduction",
          "year": 2021,
          "evidenceLevel": "cohort"
        }
      ]
    }
  ],
  "relationships": [],
  "localeVariants": []
}
